/**
 * Web shim for react-native-encrypted-storage.
 *
 * On native, EncryptedStorage uses Android Keystore / iOS Keychain.
 * On web, we fall back to localStorage with a consistent Promise-based API
 * that matches the native interface.
 *
 * Security note: localStorage is NOT encrypted on web.  For production web
 * deployments, replace this with the Web Crypto API or an IndexedDB-based
 * encrypted store if sensitive data is being stored.
 */

const EncryptedStorage = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  getItem: (key) => {
    try {
      const value = localStorage.getItem(key);
      return Promise.resolve(value);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  clear: () => {
    try {
      localStorage.clear();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

export default EncryptedStorage;
